import VueRouter from 'vue-router';
import { getSettingRoutes } from './settings-routes';

function addRequiredAuth(route, value) {
	if (route.meta) {
		route.meta.requiresAuth = value;
	} else {
		route.meta = { requiresAuth: value };
	}
	return route;
}

const getSettingsRouter = () =>
	new VueRouter({
		mode: 'abstract',
		routes: getSettingRoutes().map((x) => addRequiredAuth(x, true)),
	});

export { getSettingsRouter, addRequiredAuth };
